module.exports = __webpack_public_path__ + "media/images/shiga_banner-261bef1f5954e5078c8657033afe5ace.jpg";